import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgLogOut = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
    />
  </svg>
);
export default SvgLogOut;
